var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/throttle-debounce/index.js
// module id = HzcN
// module chunks = 11